import { plugin, debug, type WidgetProps } from 'light-component';
import { Spin } from '../../spin';
import type { ReactElement } from 'react';

export function WidgetSpinner(props: WidgetProps): ReactElement {
  debug.widget('spinner', props);
  return (<Spin />);
}

plugin.register({ kind: 'widget', type: 'spinner', component: WidgetSpinner });
